module.exports = __webpack_public_path__ + "img/qilin-f-stage4-blink.98bc1e1e.png";